import PubSub from "pubsub-js";

let loginGlobal = "";
let loginCompleteGlobal = "";

const setStateLogin = (nameLogin) => {
  loginGlobal = nameLogin;
};

const getStateLogin = () => {
  return loginGlobal;
};

const setStateLoginComplete = (loginComplete) => {
  loginCompleteGlobal = loginComplete;
};

const getStateLoginComplete = () => {
  return loginCompleteGlobal;
};

export {
  setStateLogin,
  getStateLogin,
  setStateLoginComplete,
  getStateLoginComplete,
};
